import React from "react";
import { useLang } from "../contexts/LanguageContext";
import axiosClient from "../api/axiosClient";

// EN/ES toggle. Persists the choice locally always, and to the user's
// account (users.language) when logged in.
const LanguageSwitcher = ({ className = "", style = {} }) => {
  const { lang, setLang } = useLang();

  const choose = (code) => {
    if (code === lang) return;
    setLang(code);
    if (localStorage.getItem("accessToken")) {
      axiosClient
        .post("https://api.viralgpt.com/auth/settings", { language: code })
        .catch((err) => console.warn("Failed to save language preference:", err.message));
    }
  };

  const btnStyle = (active) => ({
    border: "none",
    background: "transparent",
    cursor: "pointer",
    padding: "0 4px",
    fontSize: "0.8rem",
    fontWeight: active ? 700 : 400,
    color: active ? "#635bff" : "#6b7c93",
    textDecoration: active ? "underline" : "none",
  });

  return (
    <span
      className={`d-inline-flex align-items-center ${className}`}
      style={{ whiteSpace: "nowrap", ...style }}
    >
      <i className="fas fa-globe me-1" style={{ fontSize: "0.8rem", color: "#6b7c93" }}></i>
      <button type="button" style={btnStyle(lang === "en")} onClick={() => choose("en")} aria-label="English">
        EN
      </button>
      <span style={{ color: "#6b7c93", fontSize: "0.8rem" }}>|</span>
      <button type="button" style={btnStyle(lang === "es")} onClick={() => choose("es")} aria-label="Español">
        ES
      </button>
    </span>
  );
};

export default LanguageSwitcher;
